// src/Components/Report/CustomHooks/useExpenseReport.js
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../../Helpers/config.json";

export const useExpenseReport = () => {
  const today = new Date().toISOString().split("T")[0];

  const [report, setReport] = useState({ summary: {}, expenses: [], chart_data: {} });
  const [loading, setLoading] = useState(true);
  const [from_date, setFromDate] = useState(today);
  const [to_date, setToDate] = useState(today);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const per_page = 100;

  const fetchReport = async (reset = false) => {
    setLoading(true);
    try {
      const res = await axios.get(`${config.epharmUrl}/Creport/expense-report`, {
        params: {
          start_date: from_date,
          end_date: to_date,
          search: search || undefined,
          page: reset ? 1 : page,
          per_page
        }
      });

      const data = res.data;
      setReport(prev => ({
        summary: data.summary || {},
        expenses: reset ? data.expenses : [...prev.expenses, ...data.expenses],
        chart_data: data.chart_data || {}
      }));

      setHasMore(data.expenses.length === per_page);
      if (reset) setPage(2);
      else setPage(p => p + 1);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport(true);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => fetchReport(true), 600);
    return () => clearTimeout(timer);
  }, [from_date, to_date, search]);

  const loadMore = () => !loading && hasMore && fetchReport();

  const handleChangeDate = (e) => {
    const { name, value } = e.target;
    if (name === "from_date") setFromDate(value);
    if (name === "to_date") setToDate(value);
  };

  return { loading, report, from_date, to_date, search, setSearch, handleChangeDate, loadMore, hasMore };
};